import EvaluationDetails from './EvaluationDetails'

export const ACADEMIC_PERFORMANCE_EVALUATION_TYPES = {
  RESPECT_VALUES_AND_PRINCIPLES: 'respeto-valores-y-principios',
  PERFORMANCE_AND_PROFESSIONALISM: 'rendimiento-y-profesionalismo',
  INSTITUTIONAL_PERFORMANCE: 'desempeño-institucional',
}

export default class Evaluation {
  /**
   * @type {'respeto-valores-y-principios' | 'rendimiento-y-profesionalismo' | 'desempeño-institucional'}
   */
  tipo
  id
  detalle
  reactivos

  constructor(tipo) {
    this.tipo = tipo
    this.id = 0
    this.detalle = new EvaluationDetails()
    this.reactivos = []
  }
}
